var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "almost-empty" }, [
    _c(
      "button",
      {
        staticClass: "btn bg-purple",
        class: { "btn--loading": _vm.loading },
        attrs: { disabled: _vm.loading },
        on: {
          click: function($event) {
            _vm.handleLoadMoreProfessionals()
          }
        }
      },
      [_c("span", [_vm._v("Buscar mais profissionais")])]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f9116f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f9116f0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseFlow/Components/Scheduler/Steps/ProfessionalList/LoadMore.vue
// module id = null
// module chunks = 